<template>
  <SfAssistantChecksEmpty v-if="!hasChecks" />
  <SfAssistantClearSearch v-else-if="hasNoChecksDueToSearch" />
  <SfAssistantChecksUnreadPanel
    v-else-if="selectedCategory === UNREAD_CHECKS"
  />
  <SfAssistantChecksAllPanel v-else-if="selectedCategory === ALL_CHECKS" />
  <SfAssistantChecksFilteredPanel
    v-else-if="selectedCategory === filteredCategory"
  />
  <SfAssistantChecksGeneralSectionPanel
    v-else-if="selectedCategory === GENERAL_CHECKS"
  />
  <div v-else class="tw-pb-4 tw-px-6">
    <SfAssistantChecksSectionPanel
      :workflow-id="selectedCategory"
      :context-id="selectedItem"
    >
      <template #after-checks>
        <div
          class="
            tw-mx-auto
            tw-my-4
            tw-font-medium
            tw-text-sm
            tw-text-sf-gray-light
            tw-text-center
          "
        >
          {{ I18n.t('assistant_check.page.checks.no_more') }}
        </div>
      </template>
    </SfAssistantChecksSectionPanel>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import {
  UNREAD_CHECKS,
  ALL_CHECKS,
  GENERAL_CHECKS,
} from '@app/application/sf-assistant-checks/utils'

import { filteredCategory } from '../constants'
import SfAssistantChecksEmpty from '@app/application/sf-assistant-checks/components/sf-assistant-checks-empty.vue'
import SfAssistantClearSearch from '@app/application/sf-assistant-checks/components/sf-assistant-clear-search.vue'
import SfAssistantChecksAllPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-all-panel.vue'
import SfAssistantChecksFilteredPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-filtered-panel.vue'
import SfAssistantChecksUnreadPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-unread-panel.vue'
import SfAssistantChecksSectionPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-section-panel.vue'
import SfAssistantChecksGeneralSectionPanel from '@app/application/sf-assistant-checks/components/sf-assistant-checks-general-section-panel.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { useSfAssistantChecksPage } from '../stores/page'

interface Props {
  selectedCategory: string
  selectedItem: string
}

defineProps<Props>()

const I18n = useI18n()

const sfAssistantChecksPageStore = useSfAssistantChecksPage()
const { hasChecks, hasNoChecksDueToSearch } = storeToRefs(
  sfAssistantChecksPageStore
)
</script>
